module.exports = __webpack_public_path__ + "img/up-concave.fbc6804b.svg";